import { render, staticRenderFns } from "./center_5.vue?vue&type=template&id=f25da586&scoped=true&"
import script from "./center_5.vue?vue&type=script&lang=js&"
export * from "./center_5.vue?vue&type=script&lang=js&"
import style0 from "./center_5.vue?vue&type=style&index=0&id=f25da586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25da586",
  null
  
)

export default component.exports